// 导入组件
import yzFlow from './src/index.vue'

// 为组件提供 install 安装方法，供按需引入
yzFlow.install = function (Vue) {
  Vue.component(yzFlow.name, yzFlow)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(yzFlow);
}

// 默认导出组件
export default yzFlow



// WEBPACK FOOTER //
// ./packages/yz-flow/index.js